import { render, staticRenderFns } from "./FreeTrialSwiperOSContainer.vue?vue&type=template&id=1813d58a&scoped=true"
import script from "./FreeTrialSwiperOSContainer.vue?vue&type=script&lang=ts&setup=true"
export * from "./FreeTrialSwiperOSContainer.vue?vue&type=script&lang=ts&setup=true"
import style0 from "./FreeTrialSwiperOSContainer.vue?vue&type=style&index=0&id=1813d58a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1813d58a",
  null
  
)

export default component.exports